import { fetch } from 'whatwg-fetch';
import { IpstackResponse, LocatorResponse } from './dto';
import { config } from '../config';

const baseApiUrl = config.REACT_APP_API_BASE_URL;

export const api = {
  async locator() {
    const res = await fetch(
      `${baseApiUrl}/locator?shop=${window.sslShopifyShop}&language=${navigator.language}`,
    );

    if (res.ok) {
      const json = (await res.json()) as unknown;
      const parsed = LocatorResponse.parse(json);
      return parsed;
    }

    throw new Error('Failed to load locator data');
  },
  async ipstack() {
    const res = await fetch(`${baseApiUrl}/ipstack`);

    if (res.ok) {
      const json = (await res.json()) as unknown;
      const parsed = IpstackResponse.parse(json);
      return parsed;
    }

    throw new Error('Failed to load ipstack data');
  },
};
